import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import Receipt from "./Receipt";
import Document from "./Document";
import Factor from "./Factor";
import Conflicts from "../Conflicts/Conflicts";

export default class Receipts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'receipt',
            caller: props.Caller,
            type: props.Type,
            data: null,
            loading: true,
            filters: {
                type: props.Type,
                //buildingId: this.isNull(props.BuildingId) ? this.getDefaultGuid() : props.BuildingId,
            },
            systemModuleId: 7,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0,
            currentConflictId: null,
            conflicts: []
        };
        this.setMenuId(this.state.filters.type);
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(type) {
        if (type === 1) this.state.menuId = 41;
        if (type === 2) this.state.menuId = 42;
        if (type === 3) this.state.menuId = 210;
        if (type === 4) this.state.menuId = 215;
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 3
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={3} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 3,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.setMenuId(this.state.filters.type);
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Source={null} Caller={this} Id={id} /> });
    }
    onAdd(type) {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Source={1} Type={type} Caller={this} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    showFactor(id, type) {
        this.removeKeyDown();
        this.showComponents({ component: <Factor Type={type} Caller={this} Id={id} /> });
    }
    getCaption() {
        if (this.state.filters.type === 1) return "دریافت";
        if (this.state.filters.type === 2) return "پرداخت";
        if (this.state.filters.type === 3) return 'دفتر دریافت و پرداخت';
        if (this.state.filters.type === 4) return 'انتقال وجه';
        return "";
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaption()} ها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCaption()} یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {this.state.filters.type === 1 && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(1)}><em className="icon ni ni-plus"></em>
                                                <span>ثبت دریافت جدید</span>
                                            </a>
                                        </li>}
                                        {this.state.filters.type === 2 && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(2)}><em className="icon ni ni-plus"></em>
                                                <span>ثبت پرداخت جدید</span>
                                            </a>
                                        </li>}
                                        {this.state.filters.type === 3 && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(3)}><em className="icon ni ni-plus"></em>
                                                <span>ثبت جدید</span>
                                            </a>
                                        </li>}
                                        {this.state.filters.type === 5 && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(3)}><em className="icon ni ni-plus"></em>
                                                <span>ثبت جدید</span>
                                            </a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="توضیحات" className="form-control" />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ موردی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شرح</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                            <div className="nk-tb-col text-center">
                                                {this.state.filters.type === 3 ? <span className="sub-text">از تاریخ</span> : <span className="sub-text">تاریخ</span>}
                                            </div>
                                            {this.state.filters.type === 3 && <div className="nk-tb-col text-center"><span className="sub-text">تا تاریخ</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره سند</span></div>
                                            {this.state.filters.type !== 3 && this.state.filters.type !== 4 && <div className="nk-tb-col text-center"><span className="sub-text">شماره فاکتور</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">مرحله</span></div>
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>)}
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شرح: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.description}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ: </span>
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.dateString}</span>
                                                </div>
                                                {this.state.filters.type === 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">تا تاریخ: </span>
                                                    <span className="sub-text text-center">{record.toDateString}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره سند: </span>
                                                    {record.documentNumber > 0 && <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.showDocument(record.documentId)}>{record.documentNumber}</a>
                                                    </span>}
                                                </div>
                                                {this.state.filters.type !== 3 && this.state.filters.type !== 3 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره فاکتور: </span>
                                                    {record.factorNumber > 0 && <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.showFactor(record.factorId, record.factorType)}>{record.factorNumber}</a>
                                                    </span>}
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مرحله: </span>
                                                    <span className="sub-text text-center">{record.workFlowStepName}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        <li>
                                                                            <a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                                <em className="icon ni ni-cross-fill-c"></em> حذف
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() :
                                this.renderForm()
                            }
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

            ];
        return contents;
    }
}